/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Typography, styled, Box } from '@mui/material';
import LogoPng from'../../assets/logo.png';

export const Container = styled(Box)({
  position: 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '600px'
});

export const Logo = styled((props: any) => <img src={LogoPng} {...props} alt='Logo' />)(style => ({
  width: '70%',
  padding: '10px 0'
}));

export const Message = styled((props: any) => <Typography  variant='h6' {...props}/>)(style => ({
  cursor: 'default',
  fontSize: '1.0rem',
  marginTop: '15px'
}));
